<listbox-empty [variant]="variant" [showIcon]="showIcon">
  <ng-container icon>
    <i class="uil uil-folder-slash"></i>
  </ng-container>

  <ng-container text>
    {{ "COURSES.DASHBOARD.NO_GROUPS_TO_SHOW" | translate }}
  </ng-container>
</listbox-empty>
